module.exports = __webpack_public_path__ + "static/media/smile.adc3869f.gif";